import AdaptiveQuizTable from './AdaptiveQuizTable';

export default AdaptiveQuizTable;
